module.exports = __webpack_public_path__ + "static/media/sunrise1.7358a7a2.jpg";